<h2 mat-dialog-title>{{ 'settingsSubjectModelAbbreviationEditDialog.title' | translate }}</h2>
<div class="container">
  <div class="form-content">
    <span>{{ 'settingsSubjectModelAbbreviationEditDialog.message1' | translate }}</span><br>
    <span>{{ 'settingsSubjectModelAbbreviationEditDialog.message2' | translate }}</span>
    <div class="form-div">
      <mat-form-field class="form">
        <mat-label>{{ 'settingsSubjectModelAbbreviationEditDialog.namePlaceholder' | translate }}</mat-label>
        <input matInput maxlength="{{maxLength}}"
          [formControl]="nameControl" required>
        <mat-hint align="end">{{nameControl.value?.length || 0}}/{{ maxLength }}</mat-hint>
        <mat-error *ngIf="nameControl.hasError('required')">
          {{ 'settingsSubjectModelAbbreviationEditDialog.nameRequired' | translate }}
        </mat-error>
        <mat-error *ngIf="nameControl.hasError('maxlength')">{{
          'settingsSubjectModelAbbreviationEditDialog.nameMaxLength' | translate: {nameMaxLength: maxLength} }}
        </mat-error>
        <mat-error *ngIf="nameControl.hasError('pattern') && !nameControl.hasError('required')">{{
          'settingsSubjectModelAbbreviationEditDialog.nameValid' | translate }}</mat-error>
      </mat-form-field>
      <mat-form-field class="form">
        <input matInput maxlength="{{maxLength}}" placeholder="Location Abbreviation"
          [formControl]="abbreviationControl" required>
        <mat-hint align="end">{{abbreviationControl.value?.length || 0}}/{{ maxLength }}</mat-hint>
        <mat-error *ngIf="abbreviationControl.hasError('required') && !abbreviationControl.hasError('space')">
          {{ 'settingsSubjectModelAbbreviationEditDialog.abbreviationRequired' | translate }}
        </mat-error>
        <mat-error *ngIf="abbreviationControl.hasError('maxlength')">
          {{ 'settingsSubjectModelAbbreviationEditDialog.abbreviationMaxLength' | translate: {abbreviationMaxLength:
          maxLength} }}
        </mat-error>
        <mat-error
          *ngIf="abbreviationControl.hasError('pattern') && !abbreviationControl.hasError('required') && !abbreviationControl.hasError('space')">
          {{ 'settingsSubjectModelAbbreviationEditDialog.abbreviationPattern' | translate }}
        </mat-error>
        <mat-error *ngIf="abbreviationControl.hasError('duplication') && !abbreviationControl.hasError('required')">
          {{ 'settingsSubjectModelAbbreviationEditDialog.abbreviationDuplication' | translate }}
        </mat-error>
        <mat-error *ngIf="abbreviationControl.hasError('space')">
          {{ 'settingsSubjectModelAbbreviationEditDialog.abbreviationSpace' | translate }}
        </mat-error>
      </mat-form-field>
    </div>

  </div>
  <div fxLayout="row wrap" fxLayoutAlign="center">
    <mat-dialog-actions>
      <button mat-button color="primary" mat-dialog-close>{{ 'settingsSubjectModelAbbreviationEditDialog.cancel' |
        translate }}</button>
      <button mat-raised-button color="primary" mat-dialog-close
        [disabled]="abbreviationControl.invalid || nameControl.invalid" (click)="submit()">
        {{ 'settingsSubjectModelAbbreviationEditDialog.save' | translate }}
      </button>
    </mat-dialog-actions>
  </div>
</div>
